import { render, staticRenderFns } from "./ReleaseSteps.vue?vue&type=template&id=89151b5c&scoped=true"
import script from "./ReleaseSteps.vue?vue&type=script&lang=js"
export * from "./ReleaseSteps.vue?vue&type=script&lang=js"
import style0 from "./ReleaseSteps.vue?vue&type=style&index=0&id=89151b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89151b5c",
  null
  
)

export default component.exports